import React, { useState } from "react"
import { PhotoProvider, PhotoConsumer } from "react-photo-view"
import "react-photo-view/dist/index.css"
import styled, { css } from "styled-components"
import { ZoomIn } from "@material-ui/icons"

import BackgroundImage from "./../BackgroundImage"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"

function ImageView(props) {
  const { images } = props

  const [photoIndex, setPhotoIndex] = useState(0)

  const SliderControlsOverlay = props => {
    const { index, images } = props

    const nextImage = () => {
      if (index < images?.length - 1) {
        setPhotoIndex(index + 1)
      }
    }

    const prevImage = () => {
      if (index > 0) {
        setPhotoIndex(index - 1)
      }
    }
    return (
      <Controls {...props}>
        <SliderButton
          disabled={index < 1}
          onClick={() => prevImage()}
          dir="back"
        >
          <ArrowForwardIosIcon />
        </SliderButton>
        <SliderButton
          disabled={index >= images.length - 1}
          onClick={() => nextImage()}
          dir="forward"
        >
          <ArrowForwardIosIcon />
        </SliderButton>
      </Controls>
    )
  }

  return (
    <PhotoProvider
      index={photoIndex}
      onIndexChange={setPhotoIndex}
      overlayRender={SliderControlsOverlay}
    >
      {images &&
        images.map((item, index) => {
          return (
            <PhotoConsumer
              key={index}
              src={item.url.publicURL}
              bannerVisible={true}
            >
              <div onClick={() => setPhotoIndex(index)}>
                <ImageBlock>
                  <BackgroundImage
                    bg={item.url}
                    alt={item.alt}
                    position="absolute"
                  />
                  <ZoomIn />
                </ImageBlock>
              </div>
            </PhotoConsumer>
          )
        })}
    </PhotoProvider>
  )
}

export default ImageView

export const ImageBlock = styled.div`
  position: relative;
  cursor: pointer;
  padding-bottom: 80%;
  min-height: 180px;
  width: 100%;

  svg {
    width: 30px;
    height: 30px;
    transition: all 150ms ease-in-out;
    left: calc(50% - 15px);
    top: calc(50% - 15px);
    position: absolute;
    z-index: 2;
    color: white;
    opacity: 0;
    transform: translateY(25%);
  }
  &:hover {
    svg {
      opacity: 1;
      transform: translateY(0);
    }
    &:before {
      background: rgba(0, 0, 0, 0.3);
    }
  }
  &:before {
    z-index: 1;
    transition: all 150ms ease-in-out;
    content: "";
    background: rgba(0, 0, 0, 0);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const Controls = styled.div`
  @media (max-width: 799px) {
    display: none;
  }
  pointer-events: none;
  opacity: 0;
  ${({ visible }) =>
    visible &&
    css`
      opacity: 1;
    `}
  transition: all 0.25s ease-in-out;
  position: absolute;
  z-index: 9999;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;

  display: flex;
  justify-content: space-between;
  align-items: center;
`

const SliderButton = styled.button`
  pointer-events: all;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  -webkit-appearance: none;

  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${({ disabled }) => (!disabled ? "color: white;" : "color: grey;")}

  ${({ dir }) =>
    dir === "back" &&
    css`
      svg {
        filter: drop-shadow(0px 0px 3px black);
        transform: rotate(180deg);
      }
    `}
`
